import store from '@/store';
import routes from './appRoutes';

routes.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const isAutenticated = store.getters.hasSession;
  if (requiresAuth && !isAutenticated) {
    next('/entrar');
  } else if (!requiresAuth && isAutenticated && to.path === '/feed' && to.name === null) { // Está assim por que quando utiliza botão de voltar, ele não conseguia carregar a tela de novo por causa do token
    next({ name: 'feedList' });
  } else {
    next();
  }
});

export default routes;
